import { cssGenerator } from '@yola/ws-sdk';

const { breakpointNames } = cssGenerator.constants;

const rangeModifiers = ['min', 'max'];

const breakpointPrefixes = new Set(
  Object.values(breakpointNames)
    .filter(Boolean)
    .flatMap((name) => [name, ...rangeModifiers.map((modifier) => `${modifier}-${name}`)])
);

const parsePrefixedClassToken = (token) => {
  const separatorIndex = token.indexOf(':');

  if (separatorIndex === -1) {
    return { prefix: null, token };
  }

  const prefix = token.slice(0, separatorIndex);

  if (breakpointPrefixes.has(prefix)) {
    return {
      prefix,
      token: token.slice(separatorIndex + 1),
    };
  }

  return { prefix: null, token };
};

export default parsePrefixedClassToken;
